import { render, staticRenderFns } from "./proceedingCodeInput.vue?vue&type=template&id=6134d39f&"
import script from "./proceedingCodeInput.vue?vue&type=script&lang=js&"
export * from "./proceedingCodeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports